import styled from "styled-components";

export const StyledReturn = styled.div`{
    .return-container {
        @media (min-width: 992px) {
            margin-top: 5rem;
        }
    }

    .return{
        display: flex;
        flex-direction: column;

        @media (min-width: 992px) {
            padding-bottom: 4rem;
            margin: 3rem;
        }
        @media (max-width: 991.9px) {
            padding-bottom: 3rem;
        }

        img {
            width: 105px;
            height: 105px;
            margin: 0 10px 1rem 10px;
            @media (min-width: 992px) {
                width: 189px;
                height: 189px;
                margin: 0 10px;
            }
        }

        .return-info {
            .product-name {
                font-size: 16px;
                color: #020202;
                font-weight: 700;
                padding-bottom: 1rem;
                @media (min-width: 992px) {
                    font-size: 22px;
                }
            }
        }

        .quantity-section {
            margin-left: 2.1rem;
            @media (min-width: 992px) {
                margin-left: 0;
                text-align: right;
            }
        }

        .comment-section {
            margin-top: 1rem;
            @media (min-width: 992px) {
                margin-left: 37px;
            }

            textarea {
                width: 100%;
                height: 150px;
                border-radius: 0;
            }
        }
    }

    .secondary.returnPage {

        @media (max-width: 991.9px) {
            padding: 0;
            margin: 0;
        }

        .orderRelated {
            display: block;
            margin-bottom: 1rem;
    
            @media (min-width: 992px) {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 2rem;
            }
        }
    
        .return.returnPageElement {
            margin: 0;

            .imgReturnContainer {
                display: block;
                @media (min-width: 992px) {
                    display: flex;
                }
    
                .imgReturn {
                    img {
                        width: 105px;
                        height: 105px;
                        margin: 0 10px 1rem 0;
                        @media (min-width: 992px) {
                            width: 140px;
                            height: 140px;
                            margin: 0 10px;
                        }
                    }
                }
    
                .return-info {
                    @media (min-width: 992px) {
                        padding-left: 25px;
                    }
                    .product-name {
                        font-size: 16px;
                    }
                }
            }

            .return-status {
                @media (min-width: 992px) {
                    text-align: right;
                }
            }
        }
    }

    .thankyouPage {
        text-align: center;
        justify-content: center;
        margin-top: 100px;
    }

    .returnForm {
        input {
            border-bottom: 1px solid #ced4da;
            border-top: 0;
            border-left: 0;
            border-right: 0;
        }
        .antispam {
            input[type=range] {
                -webkit-appearance: none;
                width: 100%;
                border: 0;
            }
            input[type=range]::-webkit-slider-thumb {
                -webkit-appearance: none;
                appearance: none;
                background-color: white;
                background-image: url('../webfiles/latest/images/icons/arrow-right-double.png');
                background-repeat: no-repeat;
                background-position: center;
                background-size: 16px 16px;
                height: 32px;
                width: 32px;
                margin-top: -14px;
                border-radius: 50%;
                border: 1px solid black;
                cursor: pointer;
            }
            input[type=range]::-webkit-slider-runnable-track {
                height: 3px;
                background: black;
            }
        }
        label {
            font-family: Raleway, sans-serif;
            font-weight: 700;
            letter-spacing: 2.88px;
            line-height: 24px;
            text-transform: uppercase;
            font-size: 12px;
        }
    }
}
`